(() => {
  const LEGACY_UPSELL_TEXT = 'perfect kegs to pair with your new purchase';

  const getSlides = (root) => Array.from(root.querySelectorAll('[data-kot-cart-reco]'));

  const hideLateInjectedUpsells = (drawer) => {
    if (!drawer) return;

    const textNodes = drawer.querySelectorAll('h1,h2,h3,h4,h5,p,strong,span,div');

    textNodes.forEach((element) => {
      if (element.closest('[data-kot-cart-recommendations]')) return;

      const text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text.includes(LEGACY_UPSELL_TEXT)) return;

      let container = element.closest(
        '[class*="selleasy"], [id*="selleasy"], [class*="upsell"], [id*="upsell"], [class*="recommend"], [id*="recommend"], [class*="carousel"], [class*="slider"], section'
      );

      if (!container) {
        let candidate = element.parentElement;
        while (candidate && candidate !== drawer) {
          const candidateText = (candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          const containsProtectedContent =
            candidate.querySelector('[data-kot-cart-recommendations]') ||
            candidate.querySelector('.kot-cart-total') ||
            candidate.querySelector('.kot-cart-checkout');

          if (
            candidateText.includes(LEGACY_UPSELL_TEXT) &&
            candidateText.length < 1200 &&
            !containsProtectedContent
          ) {
            container = candidate;
            break;
          }
          candidate = candidate.parentElement;
        }
      }

      if (container && container !== drawer && !container.closest('[data-kot-cart-recommendations]')) {
        container.hidden = true;
        container.setAttribute('aria-hidden', 'true');
        container.style.setProperty('display', 'none', 'important');
      }
    });
  };

  const showSlide = (root, direction) => {
    const slides = getSlides(root);
    if (slides.length < 2) return;

    let current = slides.findIndex((slide) => !slide.classList.contains('is-hidden'));
    if (current < 0) current = 0;

    slides[current].classList.add('is-hidden');
    const next = (current + direction + slides.length) % slides.length;
    slides[next].classList.remove('is-hidden');
  };

  const attachSwipe = (root) => {
    const viewport = root.querySelector('.kot-cart-recommendations__viewport');
    if (!viewport || viewport.dataset.kotSwipeReady === 'true') return;

    viewport.dataset.kotSwipeReady = 'true';

    let startX = null;
    let startY = null;

    viewport.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      (event) => {
        if (startX === null || startY === null) return;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        startX = null;
        startY = null;

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        showSlide(root, deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );
  };

  const prepareSlider = (root) => {
    if (!root) return;

    const slides = getSlides(root);
    const arrows = root.querySelectorAll('[data-kot-cart-prev], [data-kot-cart-next]');

    arrows.forEach((arrow) => {
      arrow.hidden = slides.length < 2;
    });

    if (slides.length && !slides.some((slide) => !slide.classList.contains('is-hidden'))) {
      slides[0].classList.remove('is-hidden');
    }

    attachSwipe(root);
  };

  const initialiseSliders = (scope = document) => {
    scope.querySelectorAll?.('[data-kot-cart-recommendations]').forEach(prepareSlider);
  };

  const releaseStaleScrollLock = () => {
    const openDrawer = document.querySelector('cart-drawer.active');
    if (openDrawer) return;

    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');

    if (typeof removeTrapFocus === 'function') {
      try {
        removeTrapFocus();
      } catch (error) {
        // Dawn may already have released focus.
      }
    }
  };

  const attachDrawerGuards = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.kotGuardReady === 'true') return;

    drawer.dataset.kotGuardReady = 'true';

    const classObserver = new MutationObserver(() => {
      if (!drawer.classList.contains('active')) {
        window.requestAnimationFrame(releaseStaleScrollLock);
      }
    });

    classObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });

    let contentFrame = null;
    const contentObserver = new MutationObserver(() => {
      if (contentFrame) window.cancelAnimationFrame(contentFrame);
      contentFrame = window.requestAnimationFrame(() => {
        initialiseSliders(drawer);
        hideLateInjectedUpsells(drawer);
      });
    });

    contentObserver.observe(drawer, {
      childList: true,
      subtree: true,
    });

    hideLateInjectedUpsells(drawer);
  };

  const initialise = () => {
    const drawer = document.querySelector('cart-drawer');
    initialiseSliders(drawer || document);
    hideLateInjectedUpsells(drawer);
    attachDrawerGuards();
    releaseStaleScrollLock();
  };

  document.addEventListener('click', async (event) => {
    const previous = event.target.closest('[data-kot-cart-prev]');
    if (previous) {
      const root = previous.closest('[data-kot-cart-recommendations]');
      if (root) showSlide(root, -1);
      return;
    }

    const next = event.target.closest('[data-kot-cart-next]');
    if (next) {
      const root = next.closest('[data-kot-cart-recommendations]');
      if (root) showSlide(root, 1);
      return;
    }

    if (event.target.closest('.drawer__close, #CartDrawer-Overlay')) {
      window.setTimeout(releaseStaleScrollLock, 450);
      return;
    }

    const addButton = event.target.closest('[data-kot-cart-add]');
    if (!addButton) return;

    event.preventDefault();
    const variantId = Number(addButton.dataset.variantId);
    if (!variantId || addButton.disabled) return;

    const label = addButton.querySelector('span');
    const originalText = label?.textContent || 'Add';
    addButton.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body,
      });

      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Could not add product.');

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
        window.setTimeout(() => {
          initialiseSliders(drawer);
          hideLateInjectedUpsells(drawer);
        }, 80);
      }
    } catch (error) {
      console.error(error);
      addButton.disabled = false;
      if (label) label.textContent = originalText;
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') {
      window.setTimeout(releaseStaleScrollLock, 450);
    }
  });

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);
  window.addEventListener('pageshow', initialise);
})();
